import React, { useState, useEffect } from "react";
import { Variables } from "../../Variables1/Variables";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
    Row,
    Col,
    Modal,
    Button,
    Form,
    Card,
    FormCheck,
} from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import CustomSnipper from "../../components/customSnipper";
import Util from "../../Classes/Util";
import { BiLowVision } from "react-icons/bi";
import Pagination from "../../components/Pagination";

var sortJsonArray = require("sort-json-array");


const SlideList = () => {
    const navigate = useNavigate();
    const [loader, setLoader] = useState(false);
    const [slides, setSlides] = useState([]);
    const [publishModelShow, setPublishModelShow] = useState(0);
    const [search, SetSearch] = useState("");
    const [filteredData, setFilteredData] = useState([]);
    const [Permissions, setPermissions] = useState(
        Util.decrypt(localStorage.getItem("rpmRRTLx12"))
    );
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalCount, setTotalCount] = useState(0);

    // Get Slides list
    const GetSlidesList = async () => {
        setLoader(true);
        let response = await fetch(Variables.API_URL + `Slider/GetSlidesList?pageNumber=${pageNumber}&pageSize=${pageSize}`, {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        });
        let result = await response.json();
        if (response.status === 200) {
            setSlides(result.Items);
            setFilteredData(result.Items);
            setTotalCount(result.TotalCount);
        }
        setLoader(false);
    };

    // handle Search
    const handleSearch = (event) => {
        let value = event.target.value.toLowerCase();
        let result = [];
        SetSearch(value);
        result = slides.filter((data) => {
            return (
                data.Title.toLowerCase().search(value) !== -1
            );
        });
        setFilteredData(result);
    };


    // Publish / Unpublish Slide
    const PublishUnpublishSlide = async (slideId) => {
        let response = await fetch(
            Variables.API_URL + "Slider/PublishUnpublishSlide/" + slideId,
            {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            }
        );
        let result = await response.json();
        if (response.status === 200) {
            toast.success(result, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            setPublishModelShow(0);
            GetSlidesList();
        } else {
            toast.error(result, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    };
    //#region Sorting

    const [titleSort, setTitleSort] = useState("asc");
    const [subTitleSort, setSubTitleSort] = useState("asc");
    const [publishSort, setPublishSort] = useState("asc");
    const [imageSort, setImageSort] = useState("asc");
    // sort by Ttile
    const SortByTitle = () => {
        var copy = [...filteredData];
        if (titleSort == "asc") {
            var x = sortJsonArray(copy, "Title", "des");
            setTitleSort("des");
        } else {
            var x = sortJsonArray(copy, "Title");
            setTitleSort("asc");
        }
        setFilteredData(x);
    };
    // sort by Ttile
    const SortBySubTitle = () => {
        var copy = [...filteredData];
        if (subTitleSort == "asc") {
            var x = sortJsonArray(copy, "Title", "des");
            setSubTitleSort("des");
        } else {
            var x = sortJsonArray(copy, "Title");
            setSubTitleSort("asc");
        }
        setFilteredData(x);
    };
    // sort by Image
    const SortByImage = () => {
        var copy = [...filteredData];
        if (imageSort == "asc") {
            var x = sortJsonArray(copy, "Image", "des");
            setImageSort("des");
        } else {
            var x = sortJsonArray(copy, "Image");
            setImageSort("asc");
        }
        setFilteredData(x);
    };

    // sort by Publish
    const SortByPublish = () => {
        var copy = [...filteredData];
        if (publishSort == "asc") {
            var x = sortJsonArray(copy, "IsPublished", "des");
            setPublishSort("des");
        } else {
            var x = sortJsonArray(copy, "IsPublished");
            setPublishSort("asc");
        }
        setFilteredData(x);
    };

    //#endregion
    useEffect(() => {
        GetSlidesList();
    }, [pageNumber, pageSize])

    return (
        <div>
            <Row>
                <Col sm="12">
                    <Card>
                        <Card.Header className="d-flex justify-content-between">
                            <div className="header-title">
                                <h4 className="card-title">Slides List</h4>
                            </div>
                            {Permissions.ManageContents === true && (
                                <Button
                                    variant="primary"
                                    onClick={() => navigate("/Slides/0")}
                                >
                                    Add New Slide
                                </Button>
                            )}
                        </Card.Header>
                        <Card.Body className="px-0">
                            <Form.Control
                                id="Search"
                                name="Search"
                                placeholder="Search"
                                type="text"
                                className="allignCenter"
                                onChange={handleSearch}
                            />
                            {loader === true ? (
                                <CustomSnipper />
                            ) : (
                                <div className="table-responsive">
                                    <table
                                        id="user-list-table"
                                        className="table table-striped"
                                        role="grid"
                                        data-toggle="data-table"
                                    >
                                        <thead>
                                            <tr className="ligth">
                                                <th>#</th>
                                                <th onClick={() => SortByImage()}></th>
                                                <th onClick={() => SortByTitle()}>Title</th>
                                                <th onClick={() => SortBySubTitle()}>SubTitle</th>
                                                <th onClick={() => SortByPublish()}>IsPublished</th>
                                                <th min-width="100px">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredData.map((tdata, index) => (
                                                <tr key={index}>
                                                    <td className="text-center">{index + 1}</td>
                                                    <td className="text-center">
                                                        <img
                                                            src={Variables.imagePath + tdata.Image}
                                                            className="bg-soft-primary rounded img-fluid avatar-40 me-3"
                                                            alt="Boat on Calm Water"
                                                        />
                                                    </td>
                                                    <td>{tdata.Title}</td>
                                                    <td>{tdata.Subtitle}</td>
                                                    <td>
                                                        <span
                                                            className={
                                                                tdata.IsPublished === false
                                                                    ? "badge bg-danger"
                                                                    : "badge bg-success"
                                                            }
                                                        >
                                                            {tdata.IsPublished === false
                                                                ? "Unpublished"
                                                                : "Published"}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        {Permissions.ManageContents === true && (
                                                            <div className="flex align-items-center list-user-action">
                                                                <Link
                                                                    className="btn btn-sm btn-icon btn-warning"
                                                                    data-toggle="tooltip"
                                                                    data-placement="top"
                                                                    title=""
                                                                    data-original-title="Lock"
                                                                    to="#"
                                                                    onClick={() =>
                                                                        setPublishModelShow(tdata.SlideId)
                                                                    }
                                                                >
                                                                    <BiLowVision />
                                                                </Link>{" "}
                                                                <Modal
                                                                    show={tdata.SlideId === publishModelShow}
                                                                    onHide={() => setPublishModelShow(0)}
                                                                >
                                                                    <Modal.Header closeButton>
                                                                        <Modal.Title as="h5">
                                                                            {tdata.isDeleted
                                                                                ? "Unpublish Slide"
                                                                                : "Publish Slide"}
                                                                        </Modal.Title>
                                                                    </Modal.Header>
                                                                    <Modal.Body>
                                                                        Are you sure you want to{" "}
                                                                        {tdata.IsPublished
                                                                            ? "Unpublish : "
                                                                            : "Publish : "}
                                                                        <b>{tdata.Title}</b>?
                                                                    </Modal.Body>
                                                                    <Modal.Footer>
                                                                        <Button
                                                                            variant="secondary"
                                                                            onClick={() => setPublishModelShow(0)}
                                                                        >
                                                                            Close
                                                                        </Button>
                                                                        <Button
                                                                            variant="primary"
                                                                            onClick={() =>
                                                                                PublishUnpublishSlide(tdata.SlideId)
                                                                            }
                                                                        >
                                                                            Save changes
                                                                        </Button>
                                                                    </Modal.Footer>
                                                                </Modal>
                                                                <Link
                                                                    className="btn btn-sm btn-icon btn-success"
                                                                    data-toggle="tooltip"
                                                                    data-placement="top"
                                                                    title=""
                                                                    data-original-title="Edit"
                                                                    to={"/Slides/" + tdata.SlideId}
                                                                >
                                                                    <span className="btn-inner">
                                                                        <svg
                                                                            width="20"
                                                                            viewBox="0 0 24 24"
                                                                            fill="none"
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                        >
                                                                            <path
                                                                                d="M11.4925 2.78906H7.75349C4.67849 2.78906 2.75049 4.96606 2.75049 8.04806V16.3621C2.75049 19.4441 4.66949 21.6211 7.75349 21.6211H16.5775C19.6625 21.6211 21.5815 19.4441 21.5815 16.3621V12.3341"
                                                                                stroke="currentColor"
                                                                                strokeWidth="1.5"
                                                                                strokeLinecap="round"
                                                                                strokeLinejoin="round"
                                                                            ></path>
                                                                            <path
                                                                                fillRule="evenodd"
                                                                                clipRule="evenodd"
                                                                                d="M8.82812 10.921L16.3011 3.44799C17.2321 2.51799 18.7411 2.51799 19.6721 3.44799L20.8891 4.66499C21.8201 5.59599 21.8201 7.10599 20.8891 8.03599L13.3801 15.545C12.9731 15.952 12.4211 16.181 11.8451 16.181H8.09912L8.19312 12.401C8.20712 11.845 8.43412 11.315 8.82812 10.921Z"
                                                                                stroke="currentColor"
                                                                                strokeWidth="1.5"
                                                                                strokeLinecap="round"
                                                                                strokeLinejoin="round"
                                                                            ></path>
                                                                            <path
                                                                                d="M15.1655 4.60254L19.7315 9.16854"
                                                                                stroke="currentColor"
                                                                                strokeWidth="1.5"
                                                                                strokeLinecap="round"
                                                                                strokeLinejoin="round"
                                                                            ></path>
                                                                        </svg>
                                                                    </span>
                                                                </Link>{" "}
                                                            </div>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    <Pagination
                                      pageNumber={pageNumber}
                                      totalCount={totalCount}
                                      pageSize={pageSize}
                                      onPageChange={(newPage) => setPageNumber(newPage)}
                                    />
                                </div>
                            )}
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </div>
    );

}
export default SlideList;